<div class="dialog-content">
  <div mat-dialog-title class="tw-flex tw-gap-x-8 tw-justify-between">
    <div>
      {{ title }}
    </div>
    <div *ngIf="detailsForm" [formGroup]="detailsForm">
      <mat-slide-toggle
        *ngIf="detailsForm.get('isDefault')"
        [formControl]="detailsForm.get('isDefault')"
        class="dialog-content__default-profile-toggle"
        color="primary"
      >
        {{ 'common.field.default' | translate }}
      </mat-slide-toggle>
      <mat-button-toggle-group hideSingleSelectionIndicator formControlName="type" hideSingleSelectionIndicator>
        <mat-button-toggle
          *ngFor="let profileType of [monitoringProfileType.Private, monitoringProfileType.Public]"
          [value]="profileType"
          aria-label="{{ profileType }}"
        >
          {{ 'common.filter.profileType.option.' + profileType.toLowerCase() | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div mat-dialog-content>
    <form *ngIf="detailsForm" [formGroup]="detailsForm">
      <mat-form-field>
        <mat-label>{{ 'common.field.name' | translate }}*</mat-label>
        <input matInput formControlName="name" />
        <mat-error *ngIf="validationService.hasError(detailsForm, 'name', 'required')"
          >{{ 'common.validation.error.required' | translate }}
        </mat-error>
        <mat-error *ngIf="validationService.hasError(detailsForm, 'name', 'mustNotBeBlank')"
          >{{ 'common.validation.error.mustNotBeBlank' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'common.field.description' | translate }}</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <div *ngIf="subscriptionForm" class="subscription tw-flex tw-gap-x-8">
        <ui-monitoring-profile-subscription
          class="tw-basis-1/2"
          [isMultiHoursSubscription]="true"
          [subscription]="subscriptionForm"
          [subscriptionTitleTranslationKey]="subscriptionTitleTranslationKey"
          (isSubscriptionEnabled)="isSubscriptionEnabled = $event"
        ></ui-monitoring-profile-subscription>
        <!--TODO remove isDeviationVisible after unifying logic-->
        <ui-monitoring-report
          class="tw-basis-1/2"
          [isSubscriptionEnabled]="isSubscriptionEnabled"
          [reportForm]="reportForm"
          [reportItemNameList]="reportItemNameList"
          [report]="report"
          [isDeviationVisible]="isDeviationVisible"
          [maxFieldsCount]="maxFieldsCount"
        >
        </ui-monitoring-report>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="dialogRef.close(true)"></ui-action-button>
    <ui-action-button
      [action]="buttonAction.Create"
      [disabled]="isInvalid$ | async"
      (buttonClick)="createProfile.emit()"
    ></ui-action-button>
  </div>
</div>
